import jwtInterceptor from './jwtInterceptor'

export default {
  getRegattas(params) {
    return jwtInterceptor.get('/regattas', { params })
  },
  getRegatta(regattaId) {
    return jwtInterceptor.get(`/regattas/${regattaId}`)
  },
  getEvents(regattaId) {
    return jwtInterceptor.get(`/regattas/${regattaId}/events`)
  },
  getRaces(regattaId, params = {}) {
    return jwtInterceptor.get(`/regattas/${regattaId}/races`, { params })
  },
  getResults(regattaId) {
    return jwtInterceptor.get(`/regattas/${regattaId}/participants/results`)
  },
  getCacheList() {
    return jwtInterceptor.get('/cache/results')
  },
  getCachedResults(regattaId) {
    return jwtInterceptor.get(`/cache/results/${regattaId}`)
  },
  seedCache() {
    return jwtInterceptor.post('/cache/seed')
  },
  getPinnedRegattas() {
    return jwtInterceptor.get('/regattas/pinned')
  },
  setPinnedRegattas(ids) {
    return jwtInterceptor.post('/regattas/pinned', ids)
  }
}
